import { useLocation } from "react-router-dom";
import { WorkspaceNavigation } from "./WorkspaceNavigation";

const libraryGroups = [
  { id: "space", label: "Your space", items: [
    { path: "/fan-dashboard", label: "Fan Dashboard" }, { path: "/wallet", label: "Fan Wallet" },
  ] },
  { id: "library", label: "Library & experiences", items: [
    { path: "/my-orders", label: "Orders" }, { path: "/my-collectibles", label: "Collectibles" },
    { path: "/my-tickets", label: "Tickets" }, { path: "/my-experiences", label: "Experiences" },
  ] },
  { id: "connect", label: "Messages & connections", items: [
    { path: "/my-ai-messages", label: "AI Messages" }, { path: "/messages", label: "Messages" },
  ] },
];

export const LibraryNavigation = () => {
  const location = useLocation();
  return (
    <div className="library-workspace-navigation" data-testid="library-workspace-navigation">
      <WorkspaceNavigation groups={libraryGroups} pathname={location.pathname} scope="library" title="Your library" />
    </div>
  );
};